import React, { useState } from "react";
import "../styles/Questions.css";

function Questions({ questions, responses, setResponses, onComplete }) {
  const [currentIndex, setCurrentIndex] = useState(0); // Index de la question courante
  const [loadingResults, setLoadingResults] = useState(false); // État pour le loader

  const currentQuestion = questions[currentIndex];

  // Gérer la réponse utilisateur
  const handleResponseChange = (e) => {
    setResponses({
      ...responses,
      [currentIndex]: e.target.value, // Stocker la réponse pour la question actuelle
    });
  };

  // Vérifie si la réponse à la question actuelle est remplie
  const isCurrentResponseValid =
    responses[currentIndex] && responses[currentIndex].trim() !== "";

  // Gérer la navigation
  const goToNextQuestion = () => {
    if (currentIndex < questions.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // Afficher le loader et appeler la fonction onComplete
      setLoadingResults(true);
      onComplete();
    }
  };

  const goToPreviousQuestion = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  // Calcul de l'avancement
  const progressPercentage = Math.round(
    ((currentIndex + 1) / questions.length) * 100
  );

  if (loadingResults) {
    // Affiche le loader si les résultats sont en cours de calcul
    return (
      <div className="loader-container">
        <div className="loader"></div>
        <p>Chargement des résultats...</p>
      </div>
    );
  }

  return (
    <div className="questions-container">
      {/* Barre de progression */}
      <div className="progress-bar">
        <div
          className="progress"
          style={{ width: `${progressPercentage}%` }}
        ></div>
      </div>
      <p className="progress-text">
        Question {currentIndex + 1} sur {questions.length} ({progressPercentage}%
        complété)
      </p>

      {/* Affichage de la question */}
      <div className="question-wrapper">
        <p className="question-text">{currentQuestion.text}</p>

        {/* Champ de réponse */}
        {currentQuestion.type === "open" ? (
          <textarea
            value={responses[currentIndex] || ""}
            onChange={handleResponseChange}
            placeholder="Écrivez votre réponse ici..."
            rows={4}
            className="response-input"
          />
        ) : (
          <div className="choices-container">
            {currentQuestion.choices.map((choice, index) => (
              <label key={index} className="choice-label">
                <input
                  type="radio"
                  name={`question-${currentIndex}`}
                  value={choice}
                  checked={responses[currentIndex] === choice}
                  onChange={handleResponseChange}
                />
                {choice}
              </label>
            ))}
          </div>
        )}
      </div>

      {/* Navigation */}
      <div className="navigation-buttons">
        <button
          className="nav-button"
          onClick={goToPreviousQuestion}
          disabled={currentIndex === 0}
        >
          Précédent
        </button>
        <button
          className="nav-button"
          onClick={goToNextQuestion}
          disabled={!isCurrentResponseValid}
        >
          {currentIndex === questions.length - 1 ? "Terminer" : "Suivant"}
        </button>
      </div>
    </div>
  );
}

export default Questions;
